"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchableTreeviewFormik = void 0;
var _lodash = require("lodash");
var React = require("react");
var SearchableTreeview_1 = require("../../Inputs/SearchableTreeview/SearchableTreeview");
var SimpleFormikWrapper_1 = require("../SimpleFormikWrapper");
var getErrorMessage = function (props, fieldName) {
    if (props && (props.errors && _lodash.get(props.errors, fieldName)) && (props.touched && _lodash.get(props.touched, fieldName))) {
        return _lodash.get(props.errors, fieldName);
    }
};
exports.SearchableTreeviewFormik = React.forwardRef(function (_a, ref) {
    var Name = _a.Name, Data = _a.Data, IsSelectedOnlyMode = _a.IsSelectedOnlyMode, SearchAriaLabel = _a.SearchAriaLabel, SearchPlaceholder = _a.SearchPlaceholder, HeaderAriaLabel = _a.HeaderAriaLabel, ShowRequired = _a.ShowRequired, FormikProps = _a.FormikProps, SelectedItems = _a.SelectedItems;
    return React.createElement(SimpleFormikWrapper_1.SimpleFormikWrapper, { Name: Name, RenderControl: function (_, _a) {
            var field = _a.field, form = _a.form;
            return (React.createElement(SearchableTreeview_1.SearchableTreeview, { OnBlur: function () {
                    if (FormikProps === null || FormikProps === void 0 ? void 0 : FormikProps.validateOnBlur) {
                        FormikProps.setFieldTouched(field.name, true);
                    }
                }, HeaderAriaLabel: HeaderAriaLabel, SelectedItems: SelectedItems, SearchAriaLabel: SearchAriaLabel, SearchPlaceholder: SearchPlaceholder, IsSelectedOnlyMode: IsSelectedOnlyMode, Data: Data, OnChange: function (selectedItems) {
                    if (FormikProps && !_lodash.isEqual(selectedItems, FormikProps.values.SearchableTreeviewFormik)) {
                        form.setFieldValue(field.name, selectedItems);
                    }
                }, ShowRequired: ShowRequired, ErrorMessage: getErrorMessage(FormikProps, field.name) }));
        } });
});
